<template>
  <div class="page-header header-filter">
    <div class="page-header-image screen-container"/>
      <div class="login-container" :class="type == 'home' ? 'pt-0 pb-0' : ''">
        <slot/>
      </div>
    </div>
</template>
<script>
  export default {
    name: 'screen-container',
    props: {
      type: {
        type: String,
        default: '',
      },
    }
  }
</script>
<style>
</style>
